import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onSubmit"]

import AppAlert from "@/components/AppAlert.vue";
import {computed, ref} from "vue";
import {useStore} from "vuex";
import {showAlert} from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPasswordChangeModal',
  props: {
    show: { type: Boolean, default: false }
  },
  emits: ["ok", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const store = useStore()

const currentPassword = ref<string>('')
const newPassword = ref<string>('')
const repeat = ref<string>('')

const onOk = async () => {
  if (newPassword.value !== repeat.value) {
    await showAlert('Das neue Passwort und die Bestätigung stimmen nicht überein!')
    return
  }

  if (!currentPassword.value) {
    await showAlert('Bitte geben Sie Ihr aktuelles Passwort ein!')
    return
  }

  if (!newPassword.value) {
    await showAlert('Bitte geben Sie ein neues Passwort ein!')
    return
  }

  if (!repeat.value) {
    await showAlert('Bitte bestätigen Sie das neue Passwort!')
    return
  }

  emit('ok', { oldPassword: currentPassword.value, newPassword: newPassword.value })
  currentPassword.value = ''
  newPassword.value = ''
  repeat.value = ''
}
const onCancel = () => {
  emit('cancel')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppAlert, {
    show: _ctx.show,
    title: "Passwort ändern",
    "show-cancel": "",
    onOk: onOk,
    onCancel: onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "form",
        onSubmit: _withModifiers(onOk, ["prevent"])
      }, [
        _createElementVNode("label", null, [
          _createTextVNode(" Aktuelles Passwort "),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPassword).value = $event)),
            autofocus: "",
            required: ""
          }, null, 512), [
            [_vModelText, currentPassword.value]
          ])
        ]),
        _createElementVNode("label", null, [
          _createTextVNode(" Neues Passwort "),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newPassword).value = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, newPassword.value]
          ])
        ]),
        _createElementVNode("label", null, [
          _createTextVNode(" Wiederholung des neuen Passworts "),
          _withDirectives(_createElementVNode("input", {
            type: "password",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((repeat).value = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, repeat.value]
          ])
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})